/* 
  请求url配置
*/
// 引入请求方法
import { httpReq } from "./httpReq";
import { downloadFile } from "./downloadFile";
import { uploadFile } from "./uploadFile";

class HttpUtil {
  /* 用户登录模块 */
  //#region
  register = (params) => httpReq("post", "/register", params);
  login = (params) => httpReq("post", "/login", params);
  //#endregion

  /* 管理员模块*/
  //#region 
  //用户管理
  //#region
  searchUsers = (params) => httpReq("post", "/searchUsers", params);

  getAllUsers = (params) => httpReq("get", "/getAllUsers", params);

  deleteUsers = (params) => httpReq("delete", "/deleteUsers", params);

  updateUsers = (params) => httpReq("put", "/updateUsers", params);

  resetUsers = (params) => httpReq("put", "/resetUsers", params);
  //#endregion

  //学生管理
  //#region
  getAllStudents = (params) => httpReq("get", "/getAllStudents", params);

  updateStudents = (params) => httpReq("put", "/updateStudents", params);

  deleteStudents = (params) => httpReq("delete", "/deleteStudents", params);

  searchStudents = (params) => httpReq("post", "/searchStudents", params);

  addStudentSingle = (params) => httpReq("post", "/addStudentSingle", params);

  downloadExcelTemplate = () => downloadFile("/downloadExcelTemplate");

  uploadStudentsExcel = (params) => uploadFile("/uploadStudentsExcel", params);
  //#endregion

  //评价指标管理
  //#region
  getAllIndicators = (params) => httpReq("post", "/getAllIndicators", params);

  addIndicator = (params) => httpReq("post", "/addIndicator", params);

  updateIndicator = (params) => httpReq("put", "/updateIndicator", params);

  deleteIndicator = (params) => httpReq("delete", "/deleteIndicator", params);
  //#endregion

  /* 数据库备份管理 */
  //#region
  getBackups = (params) => httpReq("get", "/getBackups", params);

  restoreDatabase = (params) => httpReq("post", "/restoreDatabase", params);

  deleteBackup = (params) => httpReq("delete", "/deleteBackup", params);

  backupDatabase = (params) => httpReq("post", "/backupDatabase", params);
  //#endregion

  /**评价记录管理 */
  //#region
  getAllEvaluationRecords = (params) => httpReq("get", "/getAllEvaluationRecords", params);

  updateEvaluationRecord = (params) => httpReq("put", "/updateEvaluationRecord", params);

  deleteEvaluationRecord = (params) => httpReq("delete", "/deleteEvaluationRecord", params);

  searchEvaluationRecords = (params) => httpReq("post", "/searchEvaluationRecords", params);

  markEvaluationsAsCompleted = (params) => httpReq("post", "/markEvaluationsAsCompleted", params);
  //#endregion

//#endregion

  /**学生模块 */
  //#region 
  updateUserInfo = (params) => httpReq("put", "/updateUserInfo", params);

  getEvaluationsByStudent = (params) => httpReq("post", "/getEvaluationsByStudent", params);

  submitDraftApplication = (params) => httpReq("post", "/submitDraftApplication", params);

  deleteDraftEvaluation = (params) =>  httpReq("delete", "/deleteDraftEvaluation", params);

  submitApplication = (params) => uploadFile("/submitApplication", params);
  
  getEnrollmentDateByStudent = (params) => httpReq("post", "/getEnrollmentDateByStudent", params);

  generateEvaluationResult = (params) => httpReq("post", "/generateEvaluationResult", params);

  getEvaluationResult = (params) => httpReq("post", "/getEvaluationResult", params);
  //#endregion
  
  /**教师模块/辅导员 */
  //#region 
  geAllClasses = (params) => httpReq("post", "/geAllClasses", params);

  addClasses = (params) => httpReq("post", "/addClasses", params);

  deleteClasses = (params) => httpReq("delete", "/deleteClasses", params);

  getStudentsByClass = (params) => httpReq("post", "/getStudentsByClass", params);

  getEvaluationsByTeacher = (params) => httpReq("post", "/getEvaluationsByTeacher", params);

  updateEvaluationByTeacher = (params) => httpReq("post", "/updateEvaluationByTeacher", params);

  deleteEvaluationsByTeacher = (params) =>  httpReq("delete", "/deleteEvaluationsByTeacher", params);

  downloadEvaluationExcelTemplate = () => downloadFile("/downloadEvaluationExcelTemplate");

  uploadStudentEvaluationsExcel = (params) => uploadFile("/uploadStudentEvaluationsExcel", params);

  getClassEvaluationByTeacher = (params) => httpReq("post", "/getClassEvaluationByTeacher", params);


  //#endregion

  /**公示模块 */
  getClassEvaluationResults = (params) => httpReq("post", "/getClassEvaluationResults", params);

  appealEvaluationRecord = (params) => httpReq("post", "/appealEvaluationRecord", params);
  

}
export default new HttpUtil();
